/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(function () {
    if(window.location.hash && $('.bottle-list-nav').length > 0) {
    var hash = window.location.hash.substring(1);
      if(hash == "bottlelist") {
        $('.store-page-tab-area').hide();
          //       console.log(ClassName.replace('-nav', '-area'));
          $('.bottle-list-area').show();
          $('.store-nav li').removeClass('selected');
          $('a.bottle-list-nav').parent().addClass('selected');
      }
      
  } 
    if(window.location.hash && $('.on-tap-nav').length > 0) {
    var hash = window.location.hash.substring(1);
      if(hash == "ontap") {
        $('.store-page-tab-area').hide();
          //       console.log(ClassName.replace('-nav', '-area'));
          $('.on-tap-area').show();
          $('.store-nav li').removeClass('selected');
          $('a.on-tap-nav').parent().addClass('selected');
      }
      
  } 
    
      $(".store-nav li").click(function () {
          var ClassName = $(this).find('a').attr('class');
          $('.store-page-tab-area').hide();
          //       console.log(ClassName.replace('-nav', '-area'));
          $('.' + ClassName.replace('-nav', '-area')).show();
          $(".store-nav li").removeClass('selected');
          $(this).addClass('selected');
      });
  
      //   $( ".ajaxcart__checkout" ).click(function() {
      //     alert('ddd');
      //       window.location = "/cart";
  
      //     });
      ///
  
      $(".collection-sidebar__wrapper").on("click", ".boost-pfs-filter-button", function () {
          console.log('hello there');
          $([document.documentElement, document.body]).animate({
              scrollTop: $("#collection-main").offset().top
          }, 250);
      });
  
      if ($('.bottle-list').length > 0) {
          var location = $('.bottle-list').data('location');
          $.ajax({
              url: 'https://beershophq.s3.eu-west-1.amazonaws.com/bottlelistdata/' + location + '.json',
              dataType: 'json',
              success: function (dataWeGotViaJsonp) {
                  var len = dataWeGotViaJsonp.length;
                  //                         for(var i=0;i<len;i++){
                  //                             twitterEntry = dataWeGotViaJsonp[i];
                  //                             text += '<p><img src = "' + twitterEntry.user.profile_image_url_https +'"/>' + twitterEntry['text'] + '</p>'
                  //                         }
                  //                         $('#twitterFeed').html(text);
                  //                       console.log(dataWeGotViaJsonp.length);
                  $('.bottle-list').html('');
                  $.each(dataWeGotViaJsonp, function (index, element) {
                      var WrapperDiv = $('<div />').addClass('bottle-light-style-block');
                      var hr = $('<hr />').addClass('pages-hr');
                      WrapperDiv.append(hr);
  
                      var UgWrapper = $('<div />').addClass('ug-wrapper');
                      var UgRow = $('<div />').addClass('ug-row');
                      var UgCol1 = $('<div />').addClass('ug-col-s-12 ug-col-m-3').html('<h5>' + element.Style + '</h5>');
                      var UgCol2 = $('<div />').addClass('ug-col-s-12 ug-col-m-9');
                      var UgInnerRow = $('<div />').addClass('ug-row');
  
                      var UgInnerCol0 = $('<div />').addClass('ug-col-4').text('Brewery').addClass('bottle-list-header');
                      var UgInnerCol1 = $('<div />').addClass('ug-col-2').text('Country').addClass('bottle-list-header');
                      var UgInnerCol2 = $('<div />').addClass('ug-col-2').text('Size').addClass('bottle-list-header');
                      var UgInnerCol3 = $('<div />').addClass('ug-col-2').text('AVB').addClass('bottle-list-header');
                      //                         var UgInnerCol4 = $('<div />').addClass('ug-col-2').text('Drink in').addClass('bottle-list-header');
                      var UgInnerCol5 = $('<div />').addClass('ug-col-2').text('Take out').addClass('bottle-list-header');
  
                      UgInnerRow.append(UgInnerCol0).append(UgInnerCol1).append(UgInnerCol2).append(UgInnerCol3).append(UgInnerCol5);
                      UgCol2.append(UgInnerRow);
  
                      UgRow.append(UgCol1).append(UgCol2);
                      UgWrapper.append(UgRow);
  
                      $.each(element.Items, function (index2, element2) {
                          var UgItemRow = $('<div />').addClass('ug-row');
                          var UgItemMainCol1 = $('<div />').addClass('ug-col-s-12 ug-col-m-3');
                          var ProductLink = $('<a />').attr('href', '/products/' + element2.Handle).text(element2.ProductTitle)
                          UgItemMainCol1.append(ProductLink);
                          var UgItemMainCol2 = $('<div />').addClass('ug-col-s-12 ug-col-m-9');
  
                          var UgInnerItemRow = $('<div />').addClass('ug-row');
  
                          var UgInnerItemCol1 = $('<div />').addClass('ug-col-4').text(element2.Vendor);
                          var UgInnerItemCol2 = $('<div />').addClass('ug-col-2').text(element2.Country);
                          var UgInnerItemCol3 = $('<div />').addClass('ug-col-2').text(element2.Size);
                          var UgInnerItemCol4 = $('<div />').addClass('ug-col-2').text(element2.ABV);
                          //                             var UgInnerItemCol5 = $('<div />').addClass('ug-col-2').text(element2.DrinkInPrice);
                          var UgInnerItemCol6 = $('<div />').addClass('ug-col-2').text(element2.TakeOutPrice);
                          UgInnerItemRow.append(UgInnerItemCol1).append(UgInnerItemCol2).append(UgInnerItemCol3).append(UgInnerItemCol4).append(UgInnerItemCol6)
                          UgItemMainCol2.append(UgInnerItemRow);
  
                          UgItemRow.append(UgItemMainCol1).append(UgItemMainCol2);
  
                          UgWrapper.append(UgItemRow);
  
                      });
  
                      WrapperDiv.append(UgWrapper);
  
                      $('.bottle-list').append(WrapperDiv);
                  });
              },
              error: function (xhr, ajaxOptions, thrownError) {
                  // console.log(thrownError);
                  // console.log(xhr);
                  // console.log(ajaxOptions);
              }
  
          });
  
      }
  
      if ($('.on-tap-list').length > 0) {
          var location = $('.on-tap-list').data('location');
          $.ajax({
              url: 'https://beershophq.s3.eu-west-1.amazonaws.com/ontapdata/' + location + '.json',
              dataType: 'json',
              success: function (dataWeGotViaJsonp) {
                  var len = dataWeGotViaJsonp.length;
                  //                         for(var i=0;i<len;i++){
                  //                             twitterEntry = dataWeGotViaJsonp[i];
                  //                             text += '<p><img src = "' + twitterEntry.user.profile_image_url_https +'"/>' + twitterEntry['text'] + '</p>'
                  //                         }
                  //                         $('#twitterFeed').html(text);
                  //   console.log(dataWeGotViaJsonp.length);
                  $('.on-tap-list').html('');
                  $.each(dataWeGotViaJsonp, function (index, element) {
                      var WrapperDiv = $('<div />').addClass('on-tap-list-style-block');
                      var hr = $('<hr />').addClass('pages-hr');
                      WrapperDiv.append(hr);
  
                      var UgWrapper = $('<div />').addClass('ug-wrapper');
                      var UgRow = $('<div />').addClass('ug-row');
                      var UgCol1 = $('<div />').addClass('ug-col-s-12 ug-col-m-3');
                      var KegImg = $('<img />').attr('src', element.ImageUrl).addClass('on-tap-image');
                      UgCol1.append(KegImg);
  
                      var UgCol2 = $('<div />').addClass('ug-col-s-12 ug-col-m-6');
                      var KegTitle = $('<h2 />').text(element.Title);
                      var Brewer = $('<h4 />').text(element.Brewery).addClass('brewery');
                      var Desc = $('<div/>').html(element.Description);
                      UgCol2.append(KegTitle);
                      UgCol2.append(Brewer);
                      UgCol2.append(Desc);
  
  
                      var UgInnerRow = $('<div />').addClass('ug-row').addClass('on-tap-data-area');
  
                      var UgInnerCol1 = $('<div />').addClass('ug-col-6').html('<h6>Style</h6>');
                      var StyleValue = $('<h4/>').text(element.Style);
                      UgInnerCol1.append(StyleValue);
                      var UgInnerCol2 = $('<div />').addClass('ug-col-6').html('<h6>ABV</h6>');
                      var ABVValue = $('<h4/>').text(element.ABV);
                      UgInnerCol2.append(ABVValue);
  
                      UgInnerRow.append(UgInnerCol1).append(UgInnerCol2);
                      UgCol2.append(UgInnerRow);
  // console.log(element.IncludeHalfLitrePrice + ' '+ element.Title);
                      var UgCol3 = $('<div />').addClass('ug-col-s-12 ug-col-m-3');
                      if (!element.Include2LitrePrice) {
                          

                        if(element.Price500Millilitres != null) {
                            var UgPriceInnerRow = $('<div />').addClass('ug-row');

                            var UgPriceInnerCol1 = $('<div />').addClass('ug-col-6').html('<h6>1/2 Litre</h6>');
                            var OneLitrePriceValue2 = $('<h4/>').text(element.Price500Millilitres);
                            UgPriceInnerCol1.append(OneLitrePriceValue2);
                            var UgPriceInnerCol2 = $('<div />').addClass('ug-col-6').html('<h6>1 Litre</h6>');
                            var TwoLitrePriceValue = $('<h4/>').text(element.Price1Litre);
                            UgPriceInnerCol2.append(TwoLitrePriceValue);
    
                            UgPriceInnerRow.append(UgPriceInnerCol1).append(UgPriceInnerCol2);
                            UgCol3.append(UgPriceInnerRow);

                         } else {
                            var OneLitrePriceHeader = $('<h6/>').text('1 Litre');
                          var OneLitrePriceValue = $('<h4/>').text(element.Price1Litre);
                          UgCol3.append(OneLitrePriceHeader).append(OneLitrePriceValue);
                            }

                        
                      } else {
  
                          var UgPriceInnerRow = $('<div />').addClass('ug-row');

                          if(element.Price500Millilitres != null) {
                            var UgPriceInnerCol1 = $('<div />').addClass('ug-col-6').html('<h6>1/2 Litre</h6>');
                            var OneLitrePriceValue2 = $('<h4/>').text(element.Price500Millilitres);
                            UgPriceInnerCol1.append(OneLitrePriceValue2);
                            var UgPriceInnerCol2 = $('<div />').addClass('ug-col-6').html('<h6>1 Litre</h6>');
                            var TwoLitrePriceValue = $('<h4/>').text(element.Price1Litre);
                            UgPriceInnerCol2.append(TwoLitrePriceValue);
    
                            UgPriceInnerRow.append(UgPriceInnerCol1).append(UgPriceInnerCol2);
                         } else {
                            var UgPriceInnerCol1 = $('<div />').addClass('ug-col-6').html('<h6>1 Litre</h6>');
                            var OneLitrePriceValue2 = $('<h4/>').text(element.Price1Litre);
                            UgPriceInnerCol1.append(OneLitrePriceValue2);
                            var UgPriceInnerCol2 = $('<div />').addClass('ug-col-6').html('<h6>2 Litres</h6>');
                            var TwoLitrePriceValue = $('<h4/>').text(element.Price2Litres);
                            UgPriceInnerCol2.append(TwoLitrePriceValue);
    
                            UgPriceInnerRow.append(UgPriceInnerCol1).append(UgPriceInnerCol2);
                            }
                          UgCol3.append(UgPriceInnerRow);
  
                      }
  
                      UgRow.append(UgCol1).append(UgCol2).append(UgCol3);
                      UgWrapper.append(UgRow);
  
  
  
                      WrapperDiv.append(UgWrapper);
  
                      $('.on-tap-list').append(WrapperDiv);
                  });
              },
              error: function (xhr, ajaxOptions, thrownError) {
                  // console.log(thrownError);
                  // console.log(xhr);
                  // console.log(ajaxOptions);
              }
  
          });
  
      }
  
      if ($('.stock-info').length > 0) {
          var ProductId = $('.stock-info').data('id');
          $.ajax({
              url: 'https://beershop.mbinteractive.co.uk/feed/ProductStockLevels?id=' + ProductId,
              dataType: 'json',
              success: function (dataWeGotViaJsonp) {
                  var len = dataWeGotViaJsonp.length;
                  if (dataWeGotViaJsonp[0].stockNotTracked) {
                      $('.stock-info').hide();
                  } else {
                      //                         for(var i=0;i<len;i++){
                      //                             twitterEntry = dataWeGotViaJsonp[i];
                      //                             text += '<p><img src = "' + twitterEntry.user.profile_image_url_https +'"/>' + twitterEntry['text'] + '</p>'
                      //                         }
                      //                         $('#twitterFeed').html(text);
                      //   console.log(dataWeGotViaJsonp.length);
                      var AllInStock = true;
                      $('.stock-info').html('');
                      var H4Title = $('<h4 />').text('Stock');
                      $('.stock-info').append(H4Title);
                      var WrapperUL = $('<ul />').addClass('product-stock-breakdown');
                      $.each(dataWeGotViaJsonp, function (index, element) {
                          console.log(element.locationName);
                          var Li = $('<li />');
                          var Span = $('<span />').addClass('img-wrapper');
                          if (element.inStock) {
                              if (element.lowStock) {
                                  var AmberTick = $('<img />').attr('src', 'https://beershophq.s3.eu-west-1.amazonaws.com/inventoryimages/lowstock.png');
                                  Span.append(AmberTick);
                              } else {
                                  var GreenTick = $('<img />').attr('src', 'https://beershophq.s3.eu-west-1.amazonaws.com/inventoryimages/instock.png');
                                  Span.append(GreenTick);
                              }
                              Li.append(Span);
                          } else {
                              var Cross = $('<img />').attr('src', 'https://beershophq.s3.eu-west-1.amazonaws.com/inventoryimages/outofstock.png');
                              Span.append(Cross);
                              Li.append(Span);
                              AllInStock = false;
                          }
                          Li.append(element.locationName);
                          //                    .text(element.locationName)
                          if (element.additionalComments != null) {
                              var AdditionalComments = $('<span />').addClass('additional-comments').text(element.additionalComments);
                              Li.append(AdditionalComments);
                          }
                          //                                console.log(Li);
                          WrapperUL.append(Li);
                      });
                      $('.stock-info').append(WrapperUL);
                      if (!AllInStock) {
                          var GetOnlineText = $('<p />').text('Not available at your local shop? Order online today and collect in store within 3 working days.').addClass('get-online');
                          $('.stock-info').append(GetOnlineText);
                      }
                  }
              },
              error: function (xhr, ajaxOptions, thrownError) {
                  console.log(thrownError);
                  console.log(xhr);
                  console.log(ajaxOptions);
              },
              done: function () {
                  console.log('finished');
              }
  
          });
  
      }
  
  });